import { render, staticRenderFns } from "./changeChargeVerifyBpm.vue?vue&type=template&id=853afa00&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./changeChargeVerifyBpm.vue?vue&type=script&lang=js&"
export * from "./changeChargeVerifyBpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('853afa00')) {
      api.createRecord('853afa00', component.options)
    } else {
      api.reload('853afa00', component.options)
    }
    module.hot.accept("./changeChargeVerifyBpm.vue?vue&type=template&id=853afa00&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('853afa00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/changeChargeVerifyBpm.vue"
export default component.exports